import Blue from '~/core';

new Blue({
  name: 'Modal',
  selector: '.modal__trigger[data-modal-trigger]',
  setup(trigger) {
    const id = trigger.dataset.modalTrigger;
    const modal = document.querySelector(`.modal[data-modal=${id}]`);

    const close = modal.querySelector('.modal__close');
    const contentWrapper = modal.querySelector('.modal__content-wrapper');
    const videoWrapper = modal.querySelector('.modal__media-wrapper');
    const video = modal.querySelector('video');
    const iframe = modal.querySelector('iframe');
    let iframeSrc;
    iframe ? (iframeSrc = iframe.getAttribute('src')) : null;

    const stopVideo = () => {
      videoWrapper.classList.remove('is-playing');
      if (video) {
        video.pause();
      } else if (iframe) {
        iframe.removeAttribute('src');
        iframe.setAttribute('src', iframeSrc);
      }
    };

    const startVideo = () => {
      videoWrapper.classList.add('is-playing');
      video ? video.play() : null;
      iframe ? iframe.setAttribute('src', `${iframeSrc}?autoplay=1`) : null;
    };

    const openModal = () => {
      modal.classList.add('is-open');
      if (this.$browser.name === 'ios' || this.$browser.name === 'safari')
        return;
      this.$scrollLock.lock(modal);
      video ? startVideo() : null;
    };

    const closeModal = () => {
      modal.classList.remove('is-open');
      if (this.$browser.name === 'ios' || this.$browser.name === 'safari')
        return;
      this.$scrollLock.unlock(modal);
      video ? stopVideo() : null;
    };

    console.log(this.$browser.name);

    const closeWrapper = document.createElement('div');
    closeWrapper.classList.add('modal__close-wrapper');
    closeWrapper.insertAdjacentElement('afterbegin', close);
    modal.insertAdjacentElement('afterbegin', closeWrapper);

    if (
      this.$browser.name === 'chrome' &&
      this.$browser.os.toLowerCase() === 'android os'
    ) {
      video ? videoWrapper.classList.add('is-android') : null;
    }
    this.$addEvents(contentWrapper, 'click.stop', () => {});
    this.$addEvents(close, 'click.stop.prevent', closeModal);
    this.$addEvents(modal, 'click.stop.prevent', closeModal);
    this.$addEvents(trigger, 'click.stop.prevent', openModal);
    video ? this.$addEvents(video, 'ended', stopVideo) : null;
  },
});
